import clsx from "clsx";
import { FC } from "react";

interface Props {
    icon: any,
    tooltipsText: any,
    position: 'top' | 'right' | 'left' | 'bottom',
}

export const ToolTip: FC<Props> = ({ icon, tooltipsText, position }) => {
    return (
        <div className="w-auto max-w-20 group relative inline-block bg-pink-200">

            {icon}

            <div className={clsx(
                position === "top" && "bottom-full left-1/2 mb-3 -translate-x-1/2",
                position === "left" && "right-full top-1/2 mr-3 -translate-y-1/2",
                position === "right" && "left-full top-1/2 ml-3 -translate-y-1/2",
                position === "bottom" && "left-1/2 top-full mt-3 -translate-x-1/2",
                "absolute z-50 whitespace-nowrap rounded bg-black px-2 py-[6px] text-xs text-white opacity-0 group-hover:opacity-100")}
            >
                <span className={clsx(
                    position === "top" && "bottom-[-3px] left-1/2 -translate-x-1/2",
                    position === "left" && "left-[-3px] top-1/2 -translate-y-1/2",
                    position === "right" && "right-[-3px] top-1/2 -translate-y-1/2",
                    position === "bottom" && "left-1/2 top-[-3px] -translate-x-1/2",
                    "absolute left-[-3px] top-1/2 -z-10 h-2 w-2 -translate-y-1/2 rotate-45 rounded-sm bg-black"
                )}
                ></span>

                {tooltipsText}

            </div>
        </div>
    );
};